module.exports = __webpack_public_path__ + "static/banshee-6e4edcf6333cef1ed41f37f8b8eada9c.jpg";